import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { CreateAdminConfig } from '../../../utils/common';
import Checkbox from '../../common/Checkbox';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { setAppConfig } from '../../../../redux/app/appSlice';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { axiosInstance } from 'src/api/axios';
import ToastMessage from '../../common/ToastMessage';
import GenericSkeleton from '../../common/skeleton/GenericSkeleton';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import WarningComponent from '../WarningComponent';
import './priceComparison.scss';

function PriceComparison() {
  const { PriceComparison_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { appConfigs } = useSelector((state) => state.app) || {};
  const [billedAmountForMember, SetbilledAmountForMember] = useState(
    PriceComparison_Setting?.Display_Billed_Amount_Member,
  );
  const [billedAmountForAdmin, SetbilledAmountForAdmin] = useState(
    PriceComparison_Setting?.Display_Billed_Amount_Admin,
  );

  const [zphIntegrationEnabled, setZphIntegrationEnabled] = useState(
    PriceComparison_Setting?.ENABLE_ZPH_INTEGRATION || false,
  );
  //disclamer
  const [isDisclaimer, setisDisclaimer] = useState(
    PriceComparison_Setting?.Disclaimer || '',
  );
  const [updatedAppConfigs, setupdatedAppConfigs] = useState(appConfigs);
  const dispatch = useDispatch();

  useEffect(() => {
    updateConfig(
      billedAmountForMember,
      billedAmountForAdmin,
      zphIntegrationEnabled,
      isDisclaimer,
    );
  }, [
    billedAmountForMember,
    billedAmountForAdmin,
    zphIntegrationEnabled,
    isDisclaimer,
  ]);

  const updateConfig = (
    billedAmountForMember,
    billedAmountForAdmin,
    zphIntegrationEnabled,
    isDisclaimer,
  ) => {
    setupdatedAppConfigs((current) => {
      //👇️ using spread syntax (...)
      return {
        ...current,
        PriceComparison_Setting: {
          ...current.PriceComparison_Setting,

          //👇️ override values
          Display_Billed_Amount_Member: Boolean(billedAmountForMember),
          Display_Billed_Amount_Admin: Boolean(billedAmountForAdmin),
          ENABLE_ZPH_INTEGRATION: Boolean(zphIntegrationEnabled),
          Disclaimer: String(isDisclaimer),
        },
      };
    });
  };

  const updateConfiguration = async () => {
    const saveJson = CreateAdminConfig(updatedAppConfigs);
    return await axiosInstance.put(
      APIEndpoints.putUpdateConfiguration(),
      JSON.stringify(saveJson),
    );
  };

  const handleSubmit = async () => {
    try {
      const response = await updateConfiguration();
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setAppConfig(updatedAppConfigs));
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={'Updated Price Comparison Settings successfully'}
        />,
      );
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage
            type="warning"
            subTitle={'No changes were made! Please try again.'}
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle={'Network settings updation failed'}
          />,
        );
      }
    }
  };
  return (
    <div>
      <div className="parent-div">
        <div>
          <h2>Cost Estimator Tool Configuration</h2>
        </div>
        <div className="text-right my-2"></div>
      </div>
      <div className="mb-3">
        <WarningComponent onlyMemberPortal={true} />
      </div>
      <Container className="pricecomparison-configuration mtop30 activationCode m-0 pl-0">
        <Form>
          <Row>
            <Col md={8} lg={8} sm={8}>
              <p className="billed_amount mb-4">Billed Amount </p>
              <Form.Group controlId="formBasicSSN" className="mb-1">
                <div className="">
                  <Checkbox
                    inline
                    key="suppress-settings-ssn-Key"
                    label=" Display Billed Amount on the Member Portal"
                    className="d-none"
                    value={billedAmountForMember}
                    id="suppress-settings-ssn"
                    name="suppress-settings-ssn"
                    onChange={(e) =>
                      SetbilledAmountForMember(!billedAmountForMember)
                    }
                    checked={billedAmountForMember}
                  />
                </div>
                <Form.Label className="mt-3 text-format"></Form.Label>
              </Form.Group>
            </Col>
          </Row>

          {/*<Row>
            <Col md={8} lg={8} sm={8}>
              <Form.Group controlId="formBasicSSN" className="mb-1">
                <div className="">
                  <Checkbox
                    inline
                    key="suppress-settings-ssn-Key"
                    label="Display Billed Amount on the Admin Center Portal"
                    className="d-none"
                    value={billedAmountForAdmin}
                    id="suppress-settings-ssn"
                    name="suppress-settings-ssn"
                    onChange={(e) =>
                      SetbilledAmountForAdmin(!billedAmountForAdmin)
                    }
                    checked={billedAmountForAdmin}
                  />
                </div>
                <Form.Label className="mt-3 text-format"></Form.Label>
              </Form.Group>
            </Col>
          </Row> */}

          {/*<Row>
            <Col md={8} lg={8} sm={8}>
              <Form.Group controlId="formBasicSSN" className="mb-4">
                <div className="">
                  <Checkbox
                    inline
                    key="zph-integration-Key"
                    label="ZPH Integration for Cost Estimator Tool"
                    className="d-none"
                    value={zphIntegrationEnabled}
                    id="zph-integration"
                    name="zph-integration"
                    onChange={(e) =>
                      setZphIntegrationEnabled(!zphIntegrationEnabled)
                    }
                    checked={zphIntegrationEnabled}
                  />
                </div>
                <Form.Label className="mt-3 text-format"></Form.Label>
              </Form.Group>
            </Col>
          </Row> */}
          <Row>
            <Col md={12} lg={12} sm={12}>
              <p className="billed_amount">Disclaimer </p>
              <Form.Group controlId="formBasicSSN" className="mb-1">
                <Form.Label className="disclaimer-text-format">
                  When users click the Show Cost or Estimate Cost button to view
                  price estimates, the disclaimer configured below would be
                  displayed to the user.
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mx-0">
            <Col md={12} lg={12} sm={12} className="pl-0">
              <TextInput
                inputProps={{
                  isInvalid: false,
                  placeholder: 'Enter Disclaimer',
                  className: 'border-0 disclaimer-text mt-2',
                  value: isDisclaimer,
                  as: 'textarea',
                  wrap: 'hard',
                  onChange: (e) => {
                    setisDisclaimer(e.target.value);
                  },
                }}
                //label={'SCCF'}
                //footerLabel={'Example: GHP100909HP99'}
              />
            </Col>
          </Row>
        </Form>
      </Container>
      <div className="d-flex flex-wrap justify-content-end mt-5">
        <GenericButton onClick={handleSubmit} className="ml-1">
          SAVE
        </GenericButton>
      </div>
    </div>
  );
}

export default PriceComparison;
